import {
  SET_CURRENT_SEARCH_INFO,
  SET_MENU_COLLAPSED,
  SET_APPLICATION_INFO,
  SET_AI_PRODUCT_DETAIL_INFO,
  SET_SOUND_STATE,
  SET_NEWTASK_STATE,
  SET_MENUTASKFLAG_STATE,
  SET_MENU_OPEN_LIST,
  CURRENT_STATUS,
  SET_PREV_PAGE,
  SET_CURRENT_REPORT_TIME,
  SET_CURRENT_CT_REPORT_TIME,
  NATIONAL_DICT,
  IDTYPE_DICT,
  CARDTYPE_DICT,
} from '../constants/ActionTypes.js';

export const defaultState = {
  applicationInfo: {},
  reportTime: [],
  soundState: true,
  newTaskStateObj: {},
  changeMenuTaskFlag: undefined,
  prevPage: '',
  searchInfo: {
    upload11: {},
    upload9: {},
    upload6: {},
    upload8: {},
    upload1001: {},
    intelligentscreening: {},
    reviewlist: {},
    reviewIntelligentscreening: {},
    feedbacklist: {},
    reportlist: {},
    ctReportList: {},
  },
  menuCollapsed: window.document.body.clientWidth < 1366 ? true : false,
  menuOpenList: [],
};

export const current = (state = defaultState, action) => {
  let newState;
  switch (action.type) {
    case SET_CURRENT_SEARCH_INFO:
      newState = { ...state, searchInfo: action.data };
      break;
    case SET_CURRENT_REPORT_TIME:
      newState = { ...state, reportTime: action.data };
      break;
    case SET_CURRENT_CT_REPORT_TIME:
      newState = { ...state, ctReportTime: action.data };
      break;

    case NATIONAL_DICT:
      newState = { ...state, nationalDict: action.data };
      break;

    case IDTYPE_DICT:
      newState = { ...state, IDTypeDict: action.data };
      break;

    case CARDTYPE_DICT:
      newState = { ...state, cardTypeDict: action.data };
      break;

    case SET_MENU_COLLAPSED:
      newState = { ...state, menuCollapsed: action.data };
      break;

    case SET_APPLICATION_INFO:
      newState = { ...state, applicationInfo: action.data };
      break;

    case SET_AI_PRODUCT_DETAIL_INFO:
      newState = { ...state, aiProductDetailInfo: action.data };
      break;

    case SET_SOUND_STATE:
      newState = { ...state, soundState: action.data };
      break;
    case SET_NEWTASK_STATE:
      newState = { ...state, newTaskStateObj: action.data };
      break;
    case SET_MENUTASKFLAG_STATE:
      newState = { ...state, changeMenuTaskFlag: action.data };
      break;
    case SET_MENU_OPEN_LIST:
      newState = { ...state, menuOpenList: action.data };
      break;
    case CURRENT_STATUS:
      newState = {
        applicationInfo: {},
        soundState: true,
        newTaskStateObj: {},
        changeMenuTaskFlag: undefined,
        prevPage: '',
        searchInfo: {
          upload11: {},
          upload9: {},
          upload6: {},
          upload8: {},
          upload1001: {},
          intelligentscreening: {},
          reviewlist: {},
          reviewIntelligentscreening: {},
          feedbacklist: {},
          reportlist: {},
          ctReportList: {},
        },
        menuCollapsed: window.document.body.clientWidth < 1366 ? true : false,
        menuOpenList: [],
      };
      break;
    case SET_PREV_PAGE:
      newState = { ...state, prevPage: action.data };
      break;

    default:
      newState = state;
      break;
  }
  return newState;
};
